import Cookies from 'js-cookie';

// Constants
import { COOKIE_CONFIG, COOKIE_KEYS } from '@/constants';
import { UserRole } from '@shared/constants';

/**
 * Validates if a role is a valid UserRole enum value
 * @param role - Role to validate
 * @returns boolean indicating if the role is valid
 */
export const isValidUserRole = (role: unknown): role is UserRole => {
  return (
    typeof role === 'string' &&
    Object.values(UserRole).includes(role as UserRole)
  );
};

/**
 * Retrieves the user role from cookies and validates it
 * @returns UserRole or UserRole.USER if the role is not valid
 */
export const getUserRole = (): UserRole => {
  const role = Cookies.get(COOKIE_KEYS.USER_ROLE)?.toLowerCase();

  if (!isValidUserRole(role)) {
    return UserRole.USER;
  }

  return role;
};

/**
 * Sets the user role in cookies
 * @param role - UserRole to be stored
 */
export const setUserRole = (role: UserRole): void => {
  Cookies.set(COOKIE_KEYS.USER_ROLE, role.toLowerCase(), {
    expires: COOKIE_CONFIG.DEFAULT_EXPIRES,
    path: COOKIE_CONFIG.DEFAULT_PATH,
    sameSite: COOKIE_CONFIG.SAME_SITE,
    secure: COOKIE_CONFIG.SECURE,
  });
};

/**
 * Removes the user role from cookies
 */
export const clearUserRole = (): void => {
  Cookies.remove(COOKIE_KEYS.USER_ROLE, { path: COOKIE_CONFIG.DEFAULT_PATH });
};

export const setLogoutControl = (value: string): void => {
  Cookies.set(COOKIE_KEYS.LOGOUT_CONTROL, value, {
    expires: COOKIE_CONFIG.DEFAULT_EXPIRES,
    path: COOKIE_CONFIG.DEFAULT_PATH,
    sameSite: COOKIE_CONFIG.SAME_SITE,
    secure: COOKIE_CONFIG.SECURE,
  });
};

export const clearLogoutControl = (): void => {
  Cookies.remove(COOKIE_KEYS.LOGOUT_CONTROL, {
    path: COOKIE_CONFIG.DEFAULT_PATH,
  });
};
